import { useCallback, useState } from 'react';

interface IUsePagination {
  defaultPage?: number;
  pageSize?: number;
}

export const usePagination = ({ defaultPage = 1, pageSize = 15 }: IUsePagination) => {
  const [page, setPage] = useState<number>(defaultPage);

  const setNextPage = useCallback(() => setPage((p) => p + 1), []);
  const setPrevPage = useCallback(() => {
    setPage((p) => {
      if (p === 1) return 1;
      return p - 1;
    });
  }, []);

  const resetPagination = useCallback(() => setPage(1), []);

  return {
    page,
    setNextPage,
    setPrevPage,
    resetPagination,
    firstIndex: page * pageSize - pageSize,
    lastIndex: page * pageSize,
    pageSize,
  };
};
